import api from '@api';

export const getClinicBranches = async ({
  token,
  params,
  config: configProps = {},
  axiosInstance = api,
}) => {
  try {
    const config = {
      ...configProps,
      headers: {
        ...(configProps.headers ?? {}),
        Authorization: `Bearer ${token}`,
      },
      params:
        params || configProps.params
          ? {
              ...(configProps.params ?? {}),
              ...(params ?? {}),
            }
          : undefined,
    };
    const response = await axiosInstance.get(`/admin/clinics`, config);

    return response;
  } catch (error) {
    if (error.name !== 'AxiosError') {
      console.error(error);
    } else {
      console.error({
        status: error.response?.status || error.code,
        data: error.response?.data || { message: error.message },
        message: error.message,
      });
    }

    throw error;
  }
};
